interface Props {
  label: string;
  value: string | number;
  sub: string;
  colorClass: string;
}
export function MetricCard({
  label,
  value,
  sub,
  colorClass
}: Props) {
  return <div className="mc" data-id="element-375">
      <div className="ml" data-id="element-376">{label}</div>
      <div className={`mv ${colorClass}`} data-id="element-377">{value}</div>
      <div className="ms" data-id="element-378">{sub}</div>
    </div>;
}